import { useContext } from 'react';
import { SocketContext } from '../socket/SocketContext';

export const useSocket = () => {
  const context = useContext(SocketContext);

  if (!context) {
    throw new Error('useSocket must be used within a SocketProvider');
  }

  const { socket, connected, userId, emit, on, off, ...rest } = context;

  const emitWithAck = (event, data, timeout = 5000) => {
    return new Promise((resolve, reject) => {
      if (!socket || !connected) {
        reject(new Error('Socket not connected'));
        return;
      }

      const timer = setTimeout(() => {
        reject(new Error(`Timeout waiting for ${event} acknowledgment`));
      }, timeout);

      socket.emit(event, data, (response) => {
        clearTimeout(timer);
        resolve(response);
      });
    });
  };

  return {
    socket,
    connected,
    userId,
    emit,
    on,
    off,
    ...rest,
    emitWithAck
  };
};

export default useSocket;
